<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }">项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>服务详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="order-info">
            <div style="padding-top: 20px; margin-bottom: -5px;" v-if="info.status === 5">
                <el-alert
                    :title="'失败原因：'+info.verify_remark"
                    :center="true"
                    :closable="false"
                    type="error"
                >
                </el-alert>
            </div>
            <div class="status__bar">
                <div class="current-status">
                    <span class="label">当前状态：</span><span
                    class="value text-primary">{{subStatusList[info.status]}}</span>
                </div>
                <div class="pro-handlers service-info__btns" style="display: flex">
                    <div class="btn-group" style="margin-right: 10px;" v-if="info.status >= 2 && info.status <= 13">
                        <el-button
                            v-if="info.status >= 2 && info.status <= 3"
                            type="default"
                            size="small"
                            @click="goPage(`/index/project/servicerecord?id=${$route.query.id}&sub_id=${$route.query.sub_id}`)"
                        >
                            记录服务成果
                        </el-button>
                    </div>
                    <div class="btn-group" v-if="info.status === 0">
                        <el-button
                            type="primary"
                            size="small"
                            @click="changeServiceStatus($route.query.sub_id, 1)"
                        >
                            确认
                        </el-button>
                        <el-button
                            size="small"
                            type="danger"
                            style="margin-left: 10px;"
                            @click="changeServiceStatus($route.query.sub_id, 0)"
                        >
                            拒绝
                        </el-button>
                    </div>
                    <div class="btn-group" v-if="info.status === 1">
                        <el-button
                            size="small"
                            type="primary"
                            @click="messageNotify($route.query.sub_id, 6)"
                        >
                            短信提醒
                        </el-button>
                    </div>
                    <div
                        v-if="info.status === 2 || info.status === 5 || info.status === 7"
                        class="btn-group"
                    >
                        <el-button type="primary" style="margin-right: 10px;"
                                   @click="goPage(`/index/project/queryresult?id=${$route.query.id}&sub_id=${$route.query.sub_id}`)"
                                   size="small">确认成果
                        </el-button>
                    </div>
                    <div class="btn-group" v-if="info.status === 3">
                        <el-button type="primary" style="margin-right: 10px;"
                                   @click="closePayment($route.query.id, $route.query.sub_id)"
                                   size="small">取消确认
                        </el-button>
                    </div>
                    <div class="btn-group" v-if="info.status === 8">
                        <el-button type="primary" @click="messageNotify($route.query.sub_id, 8)" size="small">短信提醒
                        </el-button>
                    </div>
                    <div class="btn-group" v-if="info.status === 9">
                        <el-button type="primary"
                                   @click="goPage(`/index/project/querysettle?id=${$route.query.id}&sub_id=${$route.query.sub_id}`)"
                                   size="small">确认结算
                        </el-button>
                    </div>
                    <div class="btn-group" v-if="info.status === 13">
                        <template v-if="info.is_appraise === 0">
                            <el-button type="primary"
                                       @click="goPage(`/index/project/evaluate?id=${$route.query.id}&sub_id=${$route.query.sub_id}`)"
                                       size="small">去评价
                            </el-button>
                        </template>
                        <template v-if="info.is_appraise === 1">
                            <el-button type="default" @click="goPage(`/index/member/personal?id=${info.member.id}`)"
                                       size="small">查看评价
                            </el-button>
                        </template>
                        <el-button type="default" @click="downloadCollection" size="small">下载文件</el-button>
                    </div>
                </div>
            </div>
            <div class="area-title" style="margin-top: 20px;">服务记录</div>
            <div class="service-record" style="margin-top: 10px">
                <div :class="'step-wraper ' + ((showRecord === 1) ? 'spread' : '')">
                    <el-timeline>
                        <el-timeline-item
                            v-for="(item, index) in info.log"
                            :key="index"
                            :type="index===0 ? 'primary' : 'info'"
                            :timestamp="item.create_time">
                            <div :class="index===0 ? 'text-primary' : ''">
                                {{item.content}}
                            </div>
                        </el-timeline-item>
                    </el-timeline>
                </div>
                <div class="step-status-handle text-center" v-if="info.log.length > 3">
                    <el-button v-if="showRecord === 0" @click="showRecord = 1" size="mini" type="text">查看全部服务记录 <i
                        class="el-icon-arrow-down"></i></el-button>
                    <el-button v-else @click="showRecord = 0" size="mini" type="text">收起 <i
                        class="el-icon-arrow-up"></i></el-button>
                </div>
            </div>
        </div>
        <div class="divider" v-if="info.status !== 0 || info.status !== 1"></div>
        <div class="order-info">
            <div class="area-title">项目信息</div>
            <div class="cell-group border-top">
                <div class="cell">
                    <div class="cell-title">项目名称</div>
                    <div class="cell-value">{{info.name}}</div>
                </div>
                <div class="cell">
                    <div class="cell-title">项目编号</div>
                    <div class="cell-value">{{info.no}}</div>
                </div>
            </div>
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">创建时间</div>
                    <div class="cell-value">{{info.create_time}}</div>
                </div>
                <div class="cell">
                    <div class="cell-title">预计完成时间</div>
                    <div class="cell-value">{{info.complete_time}}</div>
                </div>
            </div>
        </div>
        <div class="divider"></div>
        <div class="order-info">
            <div class="area-title">服务信息</div>
            <div class="cell-group border-top">
                <div class="cell">
                    <div class="cell-title">服务编号</div>
                    <div class="cell-value">{{info.sub_no}}</div>
                </div>
                <div class="cell">
                    <div class="cell-title">姓名</div>
                    <div class="cell-value">
                        <router-link style="color: #246efc;" :to="`/index/member/personal?id=${info.member.id}`">
                            {{info.member.name}}
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">身份证号</div>
                    <div class="cell-value">{{info.member.idcard}}</div>
                </div>
                <div class="cell">
                    <div class="cell-title">手机号</div>
                    <div class="cell-value">{{info.member.phone}}</div>
                </div>
            </div>
        </div>
        <div class="divider" v-if="info.status>=8"></div>
        <div class="order-info" v-if="info.status>=8">
            <div class="info-area">
                <div class="area-title">支付信息</div>
                <div class="order-box">
                    <div class="cell-group border-top">
                        <div class="cell">
                            <div class="cell-title">支付总额</div>
                            <div class="cell-value">{{info.pay.pay_money}}</div>
                        </div>
                        <div class="cell">
                            <div class="cell-title">平台服务费</div>
                            <div class="cell-value">{{info.pay.service_fee}}</div>
                        </div>
                    </div>
                    <div class="cell-group">
                        <div class="cell">
                            <div class="cell-title">服务金额</div>
                            <div class="cell-value">{{info.pay.money}}</div>
                        </div>
                        <div class="cell">
                            <div class="cell-title">服务费率</div>
                            <div class="cell-value">{{info.rate}}%</div>
                        </div>
                    </div>
                    <div class="cell-group">
                        <div class="cell">
                            <div class="cell-title">个税</div>
                            <div class="cell-value">{{info.income_tax.tax}}</div>
                        </div>
                        <div class="cell">
                            <div class="cell-title">大额服务费</div>
                            <div class="cell-value">{{info.income_tax.diff_money}}</div>
                        </div>
                    </div>
                    <div class="cell-group">
                        <div class="cell">
                            <div class="cell-title">实收金额</div>
                            <div class="cell-value">{{info.income_tax.real_money}}</div>
                        </div>
                        <div class="cell">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="divider" v-if="info.service_work.length > 0"></div>
        <div class="content-box__inner" v-if="info.service_work.length > 0">
            <div class="area-title in-content">成果记录</div>
            <div class="service-work__wrapper">
                <div class="service-work" v-for="(sw, idx) in info.service_work" :key="idx">
                    <div class="abstract">
                        <div class="abstract-row">
                            <div class="committer">
                                提交人：{{sw.from}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;【 {{recordType[sw.type]}} 】
                            </div>
                            <div>
                                <span :class="'result-status ' + ['status-0', 'status-1', 'status-2', 'status-3'][sw.status]">
                                    {{['已提交', '待审核', '已通过', '未通过'][sw.status]}}
                                </span>
                            </div>
                        </div>
                        <div class="reject-reason" v-if="sw.status === 3 && sw.remark">
                            <i class="el-icon-warning-outline"></i>
                            <div class="text">原因：{{ sw.remark }}</div>
                        </div>
                    </div>
                    <div class="content-wrapper">
                        <div class="main">
                            <div class="content">
                                {{sw.content}}
                            </div>
                            <div class="pics">
                                <div class="pic-item" v-for="(pic, ids) in sw.pics" :key="'sw' + ids" @click="anyPreview(pic.src)">
                                    <i class="el-icon-paperclip"></i>
                                    <span class="filename">{{ pic.filename }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="oprate-area">
                            <el-button v-if="info.status >= 2 && info.status <= 3" type="error" size="small" @click="deleteServiceWork(sw.id)">删除</el-button>
                            <el-button v-if="sw.reset_status === 1" size="medium" @click="openResetDialog(sw)">重置状态</el-button>
                            <el-button v-if="sw.status === 1" size="medium" @click="openReviewDialog(sw)">审核</el-button>
                        </div>
                    </div>
                    <div class="time">{{sw.create_time}}</div>
                </div>
            </div>
        </div>
        <div class="divider"></div>
        <div class="content-box__inner" v-if="info.status < 8">
            <div class="area-title in-content flex">
                <div class="area-text">
                    服务需求
                </div>
                <div class="area-title__handle" v-if="info.status > 1 && info.status < 14">
                    <el-button size="small" @click="downloadQRD">下载确认单</el-button>
                </div>
            </div>
            <div class="table">
                <el-table
                    :data="service"
                >
                    <el-table-column
                        prop="name"
                        align="center"
                        width="300"
                        :show-overflow-tooltip="true"
                        label="服务名称">
                    </el-table-column>
                    <el-table-column
                        prop="unit"
                        align="center"
                        label="单位">
                    </el-table-column>
                    <el-table-column
                        prop="demand"
                        width="300"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="服务要求">
                    </el-table-column>
                    <el-table-column
                        prop="amount"
                        align="center"
                        label="预估人数">
                    </el-table-column>
                    <el-table-column
                        prop="price"
                        align="center"
                        label="预估单价">
                    </el-table-column>
                    <el-table-column
                        prop="money"
                        align="center"
                        width="140"
                        label="预估总价">
                    </el-table-column>
                </el-table>
                <div class="table__like">
                    <div class="td">总计</div>
                    <div class="td-flex"></div>
                    <div class="td">{{info.service.total}}</div>
                </div>
            </div>
        </div>
        <div class="content-box__inner tabs-content-box" v-else>
            <el-tabs value="first">
                <el-tab-pane label="服务需求" name="first">
                    <div class="table-header">
                        <div class="box">
                            <div class="box__label">项目名称:</div>
                            <div class="box__value">{{info.name}}</div>
                        </div>
                        <div class="box">
                            <div class="box__label">预计完成时间:</div>
                            <div class="box__value">{{info.complete_time}}
                                <div style="display: inline-block; margin-left: 40px;"
                                     v-if="info.status > 1 && info.status < 14">
                                    <el-button size="small" @click="downloadQRD">下载确认单</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table" style="padding: 0 0 20px">
                        <el-table
                            :data="service"
                        >
                            <el-table-column
                                prop="name"
                                align="center"
                                width="300"
                                :show-overflow-tooltip="true"
                                label="服务名称">
                            </el-table-column>
                            <el-table-column
                                prop="unit"
                                align="center"
                                label="单位">
                            </el-table-column>
                            <el-table-column
                                prop="demand"
                                align="center"
                                width="300"
                                :show-overflow-tooltip="true"
                                label="服务要求">
                            </el-table-column>
                            <el-table-column
                                prop="amount"
                                align="center"
                                label="预估人数">
                            </el-table-column>
                            <el-table-column
                                prop="price"
                                align="center"
                                label="预估单价">
                            </el-table-column>
                            <el-table-column
                                prop="money"
                                align="center"
                                width="140"
                                label="预估总价">
                            </el-table-column>
                        </el-table>
                        <div class="table__like">
                            <div class="td">总计</div>
                            <div class="td-flex"></div>
                            <div class="td">{{info.service.total}}</div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane v-if="info.confirm.listData.length > 0 && info.status > 7" label="成果确认" name="second">
                    <div class="table-header">
                        <div class="box">
                            <div class="box__label">项目名称:</div>
                            <div class="box__value">{{info.name}}</div>
                        </div>
                        <div class="box">
                            <div class="box__label">预计完成时间:</div>
                            <div class="box__value">{{info.complete_time}}
                                <div style="display: inline-block; margin-left: 40px;">
                                    <el-button size="small" @click="downloadCGQRD">下载确认单</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="page-caption">
                        <div class="cell">
                            <div class="cell__label">项目名称：</div>
                            <div class="cell__value">{{info.name}}</div>
                        </div>
                        <div class="cell">
                            <div class="cell__label">服务人员：</div>
                            <div class="cell__value">{{info.member.name}}</div>
                        </div>
                        <div class="cell">
                            <div class="cell__label">预计完成时间：</div>
                            <div class="cell__value">{{info.complete_time}}</div>
                        </div>
                    </div> -->
                    <div class="table" style="padding: 0 0 20px">
                        <el-table
                            :data="info.confirm.listData"
                        >
                            <el-table-column
                                prop="name"
                                align="center"
                                width="300"
                                :show-overflow-tooltip="true"
                                label="服务内容">
                            </el-table-column>
                            <el-table-column
                                prop="unit"
                                align="center"
                                label="单位">
                            </el-table-column>
                            <el-table-column
                                prop="demand"
                                align="center"
                                width="300"
                                :show-overflow-tooltip="true"
                                label="服务要求">
                            </el-table-column>
                            <el-table-column
                                prop="amount"
                                align="center"
                                label="确认数量">
                            </el-table-column>
                            <el-table-column
                                prop="price"
                                align="center"
                                label="确认单价">
                            </el-table-column>
                            <el-table-column
                                prop="award"
                                align="center"
                                label="奖励金额">
                            </el-table-column>
                            <el-table-column
                                prop="money"
                                align="center"
                                width="140"
                                label="服务合计">
                            </el-table-column>
                        </el-table>
                        <div class="table__like">
                            <div class="td">服务总计</div>
                            <div class="td-flex"></div>
                            <div class="td">{{info.confirm.total}}</div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane v-if="info.settlement.listData.length > 0 && info.status > 9" label="结算确认" name="third">
                    <div class="table-header">
                        <div class="box">
                            <div class="box__label">项目名称:</div>
                            <div class="box__value">{{info.name}}</div>
                        </div>
                        <div class="box">
                            <div class="box__label">预计完成时间:</div>
                            <div class="box__value">{{info.complete_time}}
                                <div style="display: inline-block; margin-left: 40px;">
                                    <el-button size="small" @click="downloadJSSQ" style="">下载结算申请</el-button>
                                    <!--                                    <Button size="small" @click="downloadJSQR">下载结算确认</Button>-->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="page-caption">
                        <div class="cell">
                            <div class="cell__label">项目名称：</div>
                            <div class="cell__value">{{info.name}}</div>
                        </div>
                        <div class="cell">
                            <div class="cell__label">服务人员：</div>
                            <div class="cell__value">{{info.member.name}}</div>
                        </div>
                        <div class="cell">
                            <div class="cell__label">预计完成时间：</div>
                            <div class="cell__value">{{info.complete_time}}</div>
                        </div>
                    </div> -->
                    <div class="table" style="padding: 0 0 20px;">
                        <el-table
                            :data="info.settlement.listData"
                        >
                            <el-table-column
                                prop="name"
                                align="center"
                                width="300"
                                :show-overflow-tooltip="true"
                                label="服务内容">
                            </el-table-column>
                            <el-table-column
                                prop="unit"
                                align="center"
                                label="单位">
                            </el-table-column>
                            <el-table-column
                                prop="demand"
                                align="center"
                                width="300"
                                :show-overflow-tooltip="true"
                                label="服务要求">
                            </el-table-column>
                            <el-table-column
                                prop="amount"
                                align="center"
                                label="确认数量">
                            </el-table-column>
                            <el-table-column
                                prop="price"
                                align="center"
                                label="确认单价">
                            </el-table-column>
                            <el-table-column
                                prop="award"
                                align="center"
                                label="奖励金额">
                            </el-table-column>
                            <el-table-column
                                prop="money"
                                align="center"
                                width="140"
                                label="服务合计">
                            </el-table-column>
                        </el-table>
                        <div class="table__like">
                            <div class="td">服务总计</div>
                            <div class="td-flex"></div>
                            <div class="td">{{info.settlement.total}}</div>
                        </div>
                        <div class="table__like">
                            <div class="td">平台服务费</div>
                            <div class="td-flex"></div>
                            <div class="td">{{info.settlement.total_fee}}</div>
                        </div>
                        <div class="table__like">
                            <div class="td">支付总额</div>
                            <div class="td-flex"></div>
                            <div class="td">{{info.settlement.pay_money}}</div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <el-dialog :visible.sync="reviewDialogVisible" title="审核服务成果">
            <el-form :model="reviewForm" label-width="80px" label-position="left">
                <el-form-item label="审核结果">
                    <el-radio-group v-model="reviewForm.result">
                        <el-radio :label="2">通过</el-radio>
                        <el-radio :label="3">不通过</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="原因" v-if="reviewForm.result === 3">
                    <el-input
                        type="textarea"
                        v-model="reviewForm.remark"
                        :rows="4"
                        placeholder="请输入不通过原因，服务者可以查看并修改"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="reviewDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitReview">提交</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="resetDialogVisible" title="重置状态" width="420px">
            <p>重置后该成果将回到“待审核”状态，确认继续重置吗？</p>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmResetStatus">确认重置</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import qs from 'qs'

export default {
    name: 'Detail',
    inject: ['goPage', 'anyPreview'],
    data () {
        const subStatusList = ['待企业确认用户服务', '待用户确认服务', '服务进行中', '待支付服务成果', '待平台审核服务成果', '审核失败，待重新确认', '服务成果待用户确认', '用户异议，待重新确认', '待用户申请结算', '待确认服务结算', '打款中', '打款失败，请联系客服', '重新发起打款', '已完成', '已关闭', '用户拒绝,已关闭']

        return {
            recordType: ['服务者记录', '发包商户记录', '项目经理记录'],
            showRecord: 0,
            subStatusList,
            service: [],
            serviceShowAll: false,
            photoViewer: {
                status: false,
                path: ''
            },
            info: {
                log: [],
                member: {},
                service: {},
                pay: {},
                confirm: {
                    listData: []
                },
                settlement: {
                    listData: []
                },
                service_work: [],
                admin_log: []
            },
            reviewDialogVisible: false,
            reviewForm: {
                result: '',
                remark: ''
            },
            currentReviewItem: null,
            resetDialogVisible: false,
            currentResetItem: null
        }
    },
    mounted () {
        this.getInfo(this.$route.query.id, this.$route.query.sub_id)
    },
    methods: {
        deleteServiceWork (id) {
            this.$confirm(`服务成果记录删除操作不可逆, 请确认是否继续操作?`, '删除服务成果记录提醒', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post('/api/user/project/delservicework', qs.stringify({
                    id
                }))
                    .then((res) => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: `服务成果记录删除成功。`
                            })
                            this.getInfo(this.$route.query.id, this.$route.query.sub_id)
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        // this.$Message.error('网络错误，请稍候再试。');
                    })
            })
        },
        getInfo (id, sub_id) {
            this.$http.get('/api/user/project/subinfo', {
                params: {
                    id,
                    sub_id
                }
            })
                .then((res) => {
                    if (res.code === 0) {
                        this.info = res.data
                        this.service = res.data.service.listData
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        },
        downloadCollection () {
            this.download(`${process.env.VUE_APP_BASE}/api/user/downprojectservice?project_id=${this.$route.query.id}&subitem_id=${this.$route.query.sub_id}`)
        },
        downloadQRD () {
            this.download(`${process.env.VUE_APP_BASE}/api/user/downconfirmlist?subitem_id=${this.$route.query.sub_id}`)
        },
        downloadCGQRD () {
            this.download(`${process.env.VUE_APP_BASE}/api/user/downconfirmresultlist?subitem_id=${this.$route.query.sub_id}`)
        },
        downloadJSSQ () {
            this.download(`${process.env.VUE_APP_BASE}/api/user/downpayapplylist?subitem_id=${this.$route.query.sub_id}`)
        },
        download (url, fileName = '') {
            let eleLink = document.createElement('a')
            let authorization = localStorage.getItem('token')
            eleLink.download = fileName
            eleLink.style.display = 'none'
            eleLink.href = url + '&authorization=' + authorization
            document.body.appendChild(eleLink)
            eleLink.click()
            document.body.removeChild(eleLink)
        },
        changeServiceStatus (sub_id, handle) {
            this.$confirm(`此操作将${handle * 1 === 1 ? '确认' : '拒绝'}服务用户, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.get('/api/user/project/subconfirm', {
                    params: {
                        id: this.$route.query.id,
                        sub_id,
                        status: handle
                    }
                })
                    .then((res) => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: `${handle * 1 === 1 ? '确认' : '拒绝'}服务用户操作成功。`
                            })
                            this.getInfo(this.$route.query.id, this.$route.query.sub_id)
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        // this.$Message.error('网络错误，请稍候再试。');
                    })
            })
        },
        closePayment (id, sub_id) {
            this.$confirm('确认取消该服务成果？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    this.queryClosePayment(id, sub_id)
                })
        },
        queryClosePayment (id, sub_id) {
            this.$http.get('/api/user/project/subtopayclose', {
                params: {
                    id,
                    sub_id
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.$notify.success({
                            title: '通知',
                            message: '服务成果取消成功。'
                        })
                        this.getInfo(this.$route.query.id, this.$route.query.sub_id)
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        messageNotify (sub_id, sign) {
            this.$confirm(`此操作将短信提醒用户操作, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post('/api/user/project/subsendsms', qs.stringify({
                    id: this.$route.query.id,
                    sub_id,
                    type: sign
                }))
                    .then((res) => {
                        if (res.code === 0 && res.data && res.data.send_status === 1) {
                            this.$notify.success({
                                title: '通知',
                                message: `短信提醒操作成功。`
                            })
                        } else if (res.code === 0) {
                            this.$message.error((res.data && res.data.msg) || '发送短信失败')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        // this.$Message.error('网络错误，请稍候再试。');
                    })
            })
        },
        openReviewDialog (item) {
            this.currentReviewItem = item
            this.reviewForm.result = 2
            this.reviewForm.remark = ''
            this.reviewDialogVisible = true
        },
        submitReview () {
            if (this.reviewForm.result === 3 && !this.reviewForm.remark) {
                this.$message.warning('请填写不通过原因')
                return
            }
            if (this.reviewForm.result === 2) {
                this.reviewForm.remark = ''
            }
            this.$http.post('/api/user/project/verifyservicework', {
                work_id: this.currentReviewItem.id,
                status: this.reviewForm.result,
                remark: this.reviewForm.remark
            })
                .then(res => {
                    if (res.code === 0) {
                        this.$message.success('审核成功')
                        this.reviewDialogVisible = false
                        // 刷新服务状态
                        this.getInfo(this.$route.query.id, this.$route.query.sub_id)
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        openResetDialog (item) {
            this.currentResetItem = item
            this.resetDialogVisible = true
        },
        confirmResetStatus () {
            if (!this.currentResetItem) {
                return
            }
            this.$http.post('/api/user/project/resetservicework', {
                work_id: this.currentResetItem.id
            })
                .then(res => {
                    if (res.code === 0) {
                        this.$message.success('状态已重置为待审核')
                        this.resetDialogVisible = false
                        this.getInfo(this.$route.query.id, this.$route.query.sub_id)
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";
    @import "../../assets/style/sub.scss";

    .order-info {
        margin-top: 20px;
        padding: 0 40px 20px;
        background-color: #fff;
    }

    .pay-form {
        width: 410px;
        margin: 53px auto;
    }

    .service-info__btns {
        button {
            &.el-button--small {
                width: 100px;
                text-align: center;
            }
        }
    }

    .cell-group {
        display: flex;
        border-right: 1px solid #ebeef5;

        &.border-top {
            border-top: 1px solid #ebeef5;
        }

        .cell {
            flex: 1;
            border-bottom: 1px solid #ebeef5;
            border-left: 1px solid #ebeef5;
            display: flex;
            align-items: center;
            color: #333333;

            .cell-title {
                background-color: #f5f5fa;
                flex: 1;
                padding: 17px 20px;
            }

            .cell-value {
                flex: 1;
                padding: 17px 20px;
                max-width: 50%;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .area-title {
        background-color: #fff;
        padding-top: 20px;
        margin-left: 0;
        font-size: 16px;
        color: $--color-primary;
        font-weight: 500;
        padding-bottom: 18px;
        position: relative;

        &::before {
            content: "";
            position: absolute;
            width: 4px;
            height: 20px;
            background-color: $--color-primary;
            left: -20px;
            top: 18px;
        }

        &.in-content {
            padding-left: 40px;

            &::before {
                left: 20px;
            }
        }

        &.flex {
            margin-right: 20px;
            display: flex;
            margin-bottom: 0;
            justify-content: space-between;
            align-items: center;

            &::before {
                top: 26px;
            }
        }
    }

    .status__bar {
        padding-top: 30px;
        display: flex;
        align-items: center;

        .current-status {
            font-size: 16px;
            font-weight: bold;
            margin-right: 45px;
        }

        .pro-handlers {

        }
    }

    .tabs-content-box {
        padding-left: 20px;
        padding-right: 20px;

        .table {
            margin-top: 20px;
        }

        .el-tabs__header {
            width: 100%;
        }
    }

    .page-caption {
        display: flex;
        margin-top: 25px;
        margin-bottom: 15px;
        padding: 0 20px;

        .cell {
            flex: 1;
            display: flex;

            &:nth-child(2) {
                justify-content: center;
            }

            &:last-child {
                justify-content: flex-end;
            }
        }
    }

    .table__like {
        display: flex;
        border-bottom: 1px solid $--border-color-light;

        .td-flex {
            flex: 1;
        }

        .td {
            text-align: center;
            padding: 12px 0;
            line-height: 23px;

            &:first-child {
                width: 300px;
            }

            &:last-child {
                width: 140px;
            }
        }
    }

    .table-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: -5px;
        margin-top: 20px;
        font-size: 14px;

        .box {
            display: flex;
            align-items: center;

            .box__value {
                margin-left: 8px;
            }
        }
    }

    .service-work__wrapper {
        border-top: 1px solid $--border-color-base;
        color: #666666;
        padding: 0 14px;

        .service-work {
            padding: 20px;
            border-bottom: 1px solid $--border-color-base;
            .result-status {
                color: #ff9800;
                font-size: 12px;
                &.status-0 {
                    color: #4B74FF;
                }

                &.status-1 {
                    color: #FFB84D;
                }

                &.status-2 {
                    color: #4B74FF;
                }

                &.status-3 {
                    color: #FF525B;
                }
            }

            .abstract {
                margin-bottom: 16px;

                .abstract-row {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .reject-reason {
                    margin-top: 6px;
                    font-size: 12px;
                    color: #FF525B;
                    display: flex;
                    align-items: flex-start;
                    line-height: 1.4;

                    i {
                        margin-right: 4px;
                        font-size: 14px;
                        line-height: 1.4;
                    }

                    .text {
                        flex: 1;
                        white-space: pre-wrap;
                    }
                }
            }
            .content-wrapper {
                display: flex;
                align-items: center;
                .main {
                    flex: 1;
                }
            }

            .content {
                line-height: 1.5;
            }

            .pics {
                margin-top: 16px;

                .pic-item {
                    color: $--color-primary;
                    align-items: center;
                    margin-right: 40px;
                    margin-bottom: 14px;
                    padding: 5px 10px 5px 0;
                    cursor: pointer;
                    text-decoration: underline;

                    span {
                        margin-left: 4px;
                    }
                }

                .download-btn {
                    cursor: pointer;
                    display: inline-block;
                    width: 140px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

            &:last-child {
                border-bottom-width: 0;
            }
        }
    }
</style>
